// extracted by mini-css-extract-plugin
module.exports = {"features_bg_desktop":"FeaturesBg_features_bg_desktop_3FUR4","features_bg_mobile":"FeaturesBg_features_bg_mobile_1Ke7H"};